// extracted by mini-css-extract-plugin
module.exports = {"container":"MobileSignUpComponent_container__Fps2L","login":"MobileSignUpComponent_login__TsvJf"};